//FIXME: Use `@airvantage/ui` `noop` once AirVantage/components#174 is merged
export function noop() {}
